import type { ReactNode } from 'react';
import { Navigate, useOutletContext } from 'react-router-dom';
import type { Product } from './api';

export function useProduct(): Product {
  return useOutletContext<Product>();
}

export function ProductGuard({
  capability,
  children,
}: {
  capability: keyof Product['capabilities'];
  children: ReactNode;
}) {
  const product = useProduct();
  return product.capabilities[capability] ? children : <Navigate to="/" replace />;
}
